
import {
  Component, PropSync, Mixins,
} from 'vue-property-decorator';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class InstalledModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;
}
